<div class="case-info">
  <img
    alt="company-image"
    class="case-info__main-icon"
    [src]="caseInfo().mainIcon.data.attributes.url"
  />
  <div class="case-info__description">{{ caseInfo().description }}</div>
  @if (caseInfo().caseProducts.data?.length > 0) {
    <div class="case-info__items product">
      <span class="case-info__subtitle">
        <noda-translate key="articles.case-info.product-used" />
      </span>
      <div class="product__list">
        @for (product of caseInfo().caseProducts.data; track product.id) {
          <div class="product__item">
            <div class="product__image-wrapper">
              <img
                class="product__image"
                [alt]="product.attributes.title"
                [src]="product.attributes.image.data.attributes.url"
              />
            </div>
            <span class="product__title">{{ product.attributes.title }}</span>
          </div>
        }
      </div>
    </div>
  }
  @if (caseInfo().flags.data?.length > 0) {
    <div class="case-info__items location">
      <span class="case-info__subtitle">
        <noda-translate key="articles.case-info.payer-location" />
      </span>
      <div class="location__list">
        @for (location of caseInfo().flags.data; track location.id) {
          <img
            alt="location"
            class="location__image"
            [src]="location.attributes.url"
          />
        }
      </div>
    </div>
  }
</div>
